var $loadMoreFeed = $("#loadMore");



function loadNews() {

var $loadingFeed = $('#loader'),
    $noMoreFeed = $('#noMore'),
    $loadingBay = $('#loadingBay'),
    totalPages, loadUrl, nextPage, nextURL, $elements;

    $body.addClass('working');
    loadUrl = $loadMoreFeed.attr('href');
    totalPages = $loadMoreFeed.data('total');
    nextPage = $loadMoreFeed.data('next');
    $loadingFeed.show();
    
  if (nextPage <= totalPages) {

    $loadingBay.load(loadUrl + ' #ajaxHolder', function() {

        $elements = $loadingBay.find('.feed-card');

        $('#ajaxHolder').append($elements);

        nextPage++;

        $loadMoreFeed.data('next', nextPage);

        if (nextPage > totalPages) {
            $loadMoreFeed.hide();
            $noMoreFeed.show();
            $loadingFeed.hide();
        }

    //   console.log(nextPage);
    //   console.log(totalPages);

        nextURL = site + '/sheaf-feed/page/' + nextPage;
        $loadMoreFeed.attr('href', nextURL);

        if (location.href != loadUrl) {
            history.pushState({}, '', loadUrl);
        }

        $loadingBay.empty();
        $body.removeClass('working');
        $loadingFeed.hide();

        $body.rhLoadIn();

        imageCards = document.querySelectorAll('.js-image-card');     
        if (typeof imageCards != "undefined" && imageCards != null) {
            feedImages();
        }

        mixCards = document.querySelectorAll('.js-mix-card');
        if (typeof mixCards != "undefined" && mixCards != null) {
            feedMixCards();
        }
        
        playVideoBtns = document.querySelectorAll(".js-play-video")
        if (typeof playVideoBtns != "undefined" && playVideoBtns != null) {
            feedVideoCards();
        }

    });

  }

}

$loadMoreFeed.on('click', function(e){
  e.preventDefault();
  loadNews();
});